<template>
  <div :class="[$style.discount, { [$style.small] : small}]">
    <b>
      -{{ discount }}%
    </b>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class DiscountBadge extends Vue {
  @Prop({ type: Number, default: 0 })
  discount!: number;

  @Prop({ type: Boolean, default: false })
  small!: boolean;
}
</script>

<style module lang="scss">
.discount {
  background-color: $primary_base;
  color: #fff;
  width: 58px;
  text-align: center;
  font-size: 16px;
  line-height: 1.5;
  padding: 6px;

  &.small {
    font-size: 14px;
    line-height: 1.4285;
    max-width: 50px;
    width: auto;
    padding: 2px;
  }
}
</style>
